module.exports = __webpack_public_path__ + "img/potencia_r_b_blue.d3b2a9e6.svg";